import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextEditControlComponent),
    multi: true
};

@Component({
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "wbo-text-edit-control",
    templateUrl: "./text-edit-control.component.html",
})
export class TextEditControlComponent extends AbstractEditControlComponent {
    @Input() public notation: string;
    @Input() public type: string;

    constructor(injector: Injector) {
        super(injector);
    }
}
